<template>
  <div v-if="firstloading" class="home">
    <!-- <img
      v-if="user && (user.user.total_draw_num > 1 || (user.user.total_draw_num == 1 && user.user.award_num > 0))"
      class="home-bg home-bg03"
      src="../../static/images/bg03.png"
      alt
    />-->
    <img
      v-if="user && (user.user.total_draw_num >= 1 || (user.user.total_draw_num == 1 && user.user.award_num > 0))"
      class="home-bg home-bg02"
      src="../../static/images/bg02.png"
      alt
    />
    <img v-else class="home-bg" src="../../static/images/bg01.png" alt />
    <!-- <img
      v-if="channel && channel == 'hbgj' && !isapp"
      class="ditch-logo02"
      src="../../static/images/ditch_hbgj.png"
      alt
    /> -->
    <div class="home-reward">
      <!-- 活动规则和我的奖品 -->
      <div class="home-rule-reward flex-row">
        <div class="home-rule-btn flex-row" @click="actRule">活动规则</div>
        <div class="home-myaward-btn flex-row" @click="myaward">我的奖品</div>
      </div>
      <div v-if="info" class="home-reward-box">
        <img class="home-reward-bg" src="../../static/images/reward_bg.png" alt />
        <div class="home-reward-winprize">
          <!-- 活动未结束时 -->
          <div v-if="!info.isover && info.status == '0'">
            <template v-if="user">
              <img
                v-if="user.user.award_num > 0 && user.user.today_draw"
                @click="getAward"
                :class="'home-reward-btn '+(truntable_status==0?'home-reward-btn2':'home-reward-btn3')"
                src="../../static/images/btn.png"
                alt
              />
              <img
                v-else-if="user.user.today_draw"
                class="home-reward-btn"
                src="../../static/images/btn03.png"
                @click="toShare"
                alt
              />
              <img
                v-else-if="user.user.today_draw"
                class="home-reward-btn"
                src="../../static/images/btn02.png"
                @click="toShare"
                alt
              />
              <img
                v-else
                class="home-reward-btn"
                @click="toShare"
                src="../../static/images/btn03.png"
                alt
              />
            </template>
            <img
              v-else
              @click="getAward"
              :class="'home-reward-btn '+(truntable_status==0?'home-reward-btn2':'home-reward-btn3')"
              src="../../static/images/btn.png"
              alt
            />
          </div>
          <!-- 活动已结束按钮 -->
          <img v-else class="home-reward-btn" src="../../static/images/active_over.png" alt />
        </div>
        <div class="home-reward-items flex-row">
          <div class="home-reward-item flex-column" v-for="(item,i) in info.award_list" :key="i">
            <img class="home-reward-icon" :src="item.logo" alt />
            <div class="home-reward-title">{{item.award_name}}</div>
            <!-- 白色背景 -->
            <div v-if="i == cur" class="home-reward-white"></div>
          </div>
        </div>
      </div>
      <!-- 轮播 -->
      <div v-if="notice" class="notice-wrap">
        <van-swipe style="height:100%;" vertical :show-indicators="false" :autoplay="3000">
          <van-swipe-item v-for="(re,i) in notice" :key="i">
            <div class="newhome-invite flex-row">
              <div class="newhome-invite-name">恭喜{{re.user_tel}}用户</div>
              <div class="newhome-invite-reward">获得{{re.award_name}}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div v-if="isbindtel && (user && user.user.total_draw_num > 0)" class="home-record-more">
        <!-- 邀请战绩 -->
        <div
          v-if="user && (user.user.total_draw_num > 1 || (user.user.total_draw_num == 1 && user.user.award_num > 0)) || clickShare"
          class="home-record-wrap"
        >
          <div class="home-rank-top flex-row">
            <div class="home-rank-people flex-column">
              <div class="home-rank-num">{{user.user.total_draw_num}}</div>
              <div>已抽奖次数</div>
            </div>
            <div class="home-rank-line"></div>
            <div class="home-rank-people flex-column">
              <!-- {{user.user.award_num}} lu修改 ，因为显示的剩余抽奖次数+已抽奖次数不能>活动的最大抽奖次数限制 -->
              <div class="home-rank-num">
                {{
                parseInt(user.user.total_draw_num)>parseInt(info.draw_total_limit)
                ?0
                :(
                parseInt(user.user.total_draw_num)+parseInt(user.user.award_num)>parseInt(info.draw_total_limit)?(parseInt(info.draw_total_limit)-parseInt(user.user.total_draw_num)):parseInt(user.user.award_num)
                )
                }}
              </div>
              <div>剩余抽奖次数</div>
            </div>
          </div>
          <img
            v-if="user.user.today_draw"
            class="home-rank-btn"
            @click="toShare"
            src="../../static/images/invite_btn.png"
            alt
          />
          <div v-else class="common-bg home-rank-btn-disabled">当日抽奖次数已达到上限</div>
          <div class="home-rank-list" @click="myinvite">查看分享列表</div>
        </div>
        <!-- 获取更多抽奖机会 -->
        <img v-if="isapp" class="home-more-wrap" src="../../static/images/rule01.png" alt />
        <!-- 渠道banner -->
        <img
          v-if="!isapp"
          class="banner_hbgj"
          src="../../static/images/banner03.jpg"
          @click="gohbgj(1)"
          alt
        />
         <img
          v-if="!isapp"
          class="banner_hbgj"
          src="../../static/images/banner04.jpg"
          @click="gohbgj(2)"
          alt
        />
        <!-- 樊登渠道banner -->
        <!-- <img
          v-if="!isapp && channel != 'guide2'"
          class="banner_hbgj"
          src="../../static/images/banner_fd.jpg"
          @click="goFanDeng"
          alt
        /> -->
      </div>
    </div>
    <!-- 中奖弹窗 box02为不中奖 -->
    <div v-if="isShow" class="home-alert flex-column">
      <div :class="{'box02':iswin == 0}" class="home-alert-box">
        <img class="alert_line" src="../../static/images/alert_line.png" alt />
        <img @click="taggleWin" class="alert_close" src="../../static/images/alert_close.png" alt />
        <template v-if="award">
          <!-- 中奖才显示 -->
          <div v-if="iswin == 1" class="text-center home-alert-title">可前往【我的奖品】查看使用</div>
          <div v-if="iswin == 1" class="home-alert-ticket flex-row">
            <div class="home-ticket-text">
              <div class="home-ticket-title">{{award.award_name}}</div>
              <div>请于{{award.expires_code}}前领取</div>
            </div>
            <img
              v-if="isapp"
              @click="useAward"
              class="home-alert-btn02"
              src="../../static/images/alert_btn03.png"
              alt
            />
            <!-- 下载app -->
            <img
              v-else
              class="home-alert-btn02 btn-clipboard"
              src="../../static/images/alert_btn03_noapp.png"
              id="btnH5"
              @click="_downloadAPP(1)"
              data-clipboard-target="#hello"
              alt
            />
            <input type="hidden" id="hello" value style="display:none;" />
          </div>
          <!-- <img
            v-if="iswin == 1"
            class="home-alert-btn"
            src="../../static/images/alert_btn01.png"
            alt
          />-->
        </template>
        <!-- 中奖才显示end -->
        <img @click="toShare" class="home-alert-btn" src="../../static/images/alert_btn02.png" alt />
      </div>
    </div>
    <!-- 规则弹窗 -->
    <div v-if="isrule" class="home-alert flex-column">
      <div class="home-alert-box rule">
        <img class="alert_line" src="../../static/images/alert_line.png" alt />
        <img @click="actRule" class="alert_close" src="../../static/images/alert_close.png" alt />
        <div class="home-rule-wrap">
          <div
            class="home-rule-item"
            v-for="(rule,idx) in info.rule_desc"
            :key="idx"
          >{{idx + 1}}、{{rule}}</div>
        </div>
        <div class="common-bg alert-rule-btn" @click="actRule">我知道了</div>
      </div>
    </div>

    <!-- 次数用完弹窗 -->
    <div v-if="isCount" class="home-count flex-column">
      <div class="home-count-box">
        <div class="flex-column home-count-boxicon">
          <img @click="closeCount" class="box_close" src="../../static/images/alert_close.png" alt />
          <img class="box_line" src="../../static/images/alert_line.png" alt />
        </div>
        <div class="home-count-text flex-column">
          <div>谢谢你的参与！</div>
          <div class="text-center">
            当前抽奖次数已经用完。将活动分享
            <br />给好友来参加活动吧！
          </div>
        </div>
        <div @click="toShare" class="home-count-btn flex-row">分享</div>
      </div>
    </div>

    <!-- 抽奖次数达到上限 -->
    <div v-if="isCountUpper" class="home-count flex-column">
      <div class="home-count-box">
        <div class="flex-column home-count-boxicon">
          <img
            @click="closeCountUpper"
            class="box_close"
            src="../../static/images/alert_close.png"
            alt
          />
          <img class="box_line" src="../../static/images/alert_line.png" alt />
        </div>
        <div class="home-count-text flex-column">
          <div>谢谢你的参与！</div>
          <div class="text-center">
            活动期间的抽奖次数已达使用上限。将这个福利
            <br />分享给好友吧！
          </div>
        </div>
        <div @click="toShare" class="home-count-btn flex-row">分享</div>
      </div>
    </div>
    <!-- 提示点击右上角分享弹窗 -->
    <div v-if="isshare" @click="showShare" class="share-alert">
      <img class="share-alert-img" src="../../static/images/share.png" alt />
    </div>
  </div>
</template>

<script>
/*
页面接口调用逻辑：
*/
import Vue from "vue";
import Alert from "../components/Alert";
import { clearInterval, setTimeout } from "timers";
import wxapi from "../assets/util/wxapi.js";

import df from "../util/dateformat.js";
import config from "@/config";
export default {
  name: "home",
  t01: null,
  data() {
    return {
      firstloading: false,
      clickShare: false,
      isapp: false,
      isshare: false,
      urlData: {}, //页面参数
      isCount: false, //次数用完的弹窗
      isCountUpper: false, //抽奖次数达到上限的弹窗
      isrule: false,
      info: null,
      notice: null,
      user: null,
      myuser: null,
      // test: new Array(9),
      turn: [0, 1, 2, 5, 8, 7, 6, 3],
      cur: -1,
      iswin: 0,
      isShow: false,
      isbindtel: false,
      award: null,
      lastid: -2,
      //转盘状态 0停止 1转动中
      truntable_status: 0,
      //转速
      truntable_speed: 50,
      //中奖结果 奖品的索引
      turntable_res: -1,
      //转盘最低转动时间
      turntable_mintime: 2000,
      //已经转动的时间
      turntable_nowtime: 0,
      //把转盘停下来的最小时间
      turntable_minstoptime: 2500,
      //把转盘停下来的最小时间
      turntable_stoptime: 0,
      //抽奖发生错误
      turntable_error: false,
      turntable_idx: 0,
      channel: "0"
    };
  },
  methods: {
    //立即使用奖品
    useAward() {
      var t = this;
      var info = t.award;
      t.isShow = false;
      if (info.issku == 1) {
        t.activeSku();
        return;
      }
      var params = {
        award_log_id: info.award_log_id
      };
      t._get("user", "User.useAward", params)
        .then(res => {
          // <el-radio-group v-model="form.code_type">
          //   <el-radio label="0">券码(无需跳转)</el-radio>
          //   <el-radio label="1">短链接(跳转)</el-radio>
          //   <el-radio label="2">二维码/条形码</el-radio>
          // </el-radio-group>;

          if (res.status == "0") {
            t._deepmain(
              "h5open3",
              "yycj#h5open3#clickbutton#receive",
              2,
              function() {
                if (
                  info.award_info.code_type == 0 &&
                  info.award_info.isme == 1
                ) {
                  console.log("---打开优惠券列表---");
                  try {
                    Jegotrip.openRnPage(
                      JSON.stringify({ funType: "couponsview", funParams: {} })
                    );
                  } catch (e) {
                    this.$Toast("网络不给力，请稍后再试");
                  }
                }
                if (info.award_info.code_type == 1) {
                  var re_href = info.award_code;
                  if (re_href.indexOf("://") < 0)
                    re_href = "http://" + info.award_code;
                  window.location.href = re_href;
                }
              }
            );
          } else {
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    //无忧行自营商品
    activeSku() {
      var t = this;
      var info = t.award;
      var params = {
        award_log_id: info.award_log_id
      };
      console.log(params);
      t._get("user", "User.activeSku", params)
        .then(res => {
          if (res.status == "0") {
            console.log("---打开优惠券列表---");
            t._deepmain(
              "h5open3",
              "yycj#h5open3#clickbutton#receive",
              2,
              function() {
                try {
                  Jegotrip.openRnPage(
                    JSON.stringify({ funType: "couponsview", funParams: {} })
                  );
                } catch (e) {
                  this.$Toast("网络不给力，请稍后再试");
                }
              }
            );
          } else {
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    // 提示右上角分享
    showShare() {
      this.isshare = !this.isshare;
    },

    // 去航班管班那里
    gohbgj(idx) {
      var t = this;
      var myurl = 'http://cp.jegotrip.com.cn/partners/Agoda/app.html?&summer20191230a';
      if(idx == 2){
         myurl = 'http://backcard.knnnj.com/pages/?uid=3971';
      }
      t._deepmain("h5open6", "yycj#h5open6#banner#hbgj", 2, function() {
        window.location.href = myurl;
      });
    },

    goFanDeng() {
      window.location.href =
        "https://j.youzan.com/S0ZZWh";
    },

    //次数用完关闭弹窗
    closeCount() {
      var t = this;
      t.isCount = !t.isCount;
      t._deepmain("h5open6", "yycj#h5open6#clickbutton", 2);
    },
    //抽奖次数达到上限
    closeCountUpper() {
      var t = this;
      t.isCountUpper = !t.isCountUpper;
      t._deepmain("h5open6", "yycj#h5open6#clickbutton", 2);
    },
    // 分享好友再抽一次
    toShare() {
      var t = this;
      t.isShow = false;
      t.isCount = false;
      t.clickShare = true;
      localStorage.setItem("clickShare", t.clickShare);
      if (
        window.navigator.userAgent.toLowerCase().match(/jegotrip/i) ==
        "jegotrip"
      ) {
        t._sharelink();
      } else {
        t.showShare();
      }
      if (t.iswin == 1) {
        t._deepmain("h5open3", "yycj#h5open3#clickbutton#receiveagain1", 2);
      } else {
        t._deepmain("h5open3", "yycj#h5open3#clickbutton#receiveagain2", 2);
      }
    },

    // 显示隐藏中奖弹窗
    taggleWin() {
      var t = this;
      t.isShow = !t.isShow;
      console.log("t.isShow");
      console.log(t.isShow);
      if (t.isShow == true) {
        if (t.iswin == 1) {
          t._deepmain("h5open3", "yycj#h5open3#clickbutton#quit1", 2);
        } else {
          t._deepmain("h5open3", "yycj#h5open3#clickbutton#quit0", 2);
        }
      }
    },
    // 活动规则
    actRule() {
      var t = this;
      t.isrule = !t.isrule;
    },

    // 查看我的邀请列表
    myinvite() {
      var t = this;
      t.$router.push({
        path: "/invitelist",
        query: {
          a: t.urlData.a
        }
      });
    },
    // 我的奖品
    myaward() {
      var t = this;
      t.$router.push({
        path: "/team",
        query: {
          a: t.urlData.a
        }
      });
      t._deepmain("clickprize", "yycj#h5open2#clickprize", 2);
    },
    // 是否绑定手机号
    signup(callback) {
      var t = this;
      var params = {
        rec_uid: t._getAPPParams().share_userid,
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._signup("signup", "SignUp.checkUser", params)
        .then(res => {
          if (res.status == 0) {
            t.isbindtel = res.data.isbindtel;
            callback(null, res);
          } else {
            callback(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    //获得活动信息
    getActivityInfo() {
      var t = this;
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._activity("activity", "Activity.getActivityInfo", params)
        .then(res => {
          if (res.status == 0) {
            var info = res.data.activity_info;
            console.log(JSON.parse(JSON.stringify(info.award_list)));
            // var a = Date.parse(new Date(res.Data.coupon_expdate));
            info.start_time_format = df.formatdate(
              "m月d日",
              info.start_time * 1000
            );
            info.end_time_format = df.formatdate(
              "m月d日",
              info.end_time * 1000
            );
            var nowtime = new Date().valueOf();
            console.log(nowtime);
            console.log(info.start_time * 1000);
            console.log(info.end_time * 1000);
            if (
              nowtime < info.start_time * 1000 ||
              nowtime > info.end_time * 1000
            ) {
              info.isover = true;
            } else {
              info.isover = false;
            }
            info.rule_desc = info.rule_desc.replace(/[\d]+[\.\、]+/g, "");
            info.rule_desc = info.rule_desc.split("\n");
            console.log("####LU:info.rule_desc", info.rule_desc);
            // 创建假的中奖数据
            t.notice = t._getLucks(info.award_list);
            console.log(t.notice);
            // 活动奖品处理
            if (info.award_list.length < 8) {
              var myobj = {
                award_name: "谢谢参与",
                logo: require("../../static/images/icon_test.png"),
                id: 0
              };
              var len = info.award_list.length;
              for (var i = 0; i < 8 - len; i++) {
                info.award_list.push(myobj);
              }
            } else {
              var array = [];
              for (var i = 0; i < info.award_list.length; i++) {
                if (i < 8) {
                  array.push(info.award_list[i]);
                }
              }
              info.award_list = array;
            }
            if (info.award_list.length == 8) {
              var myobj = {
                award_name: "抽奖",
                logo: require("../../static/images/icon_test.png"),
                id: -1
              };
              info.award_list.splice(4, 0, myobj);
            }
            t.info = info;

            t.signup(function(err, res) {
              if (!err) {
                if (t.isbindtel) {
                  t.getUser(error => {
                    t.firstloading = true;
                  });
                } else {
                  t.firstloading = true;
                }
              } else {
              }
            });
            // t.award_num = res.data.user.award_num;
            t._deepmain("yycj", "yycj#h5open1", 0);
          }
          loading.clear();
        })
        .catch(error => {
          console.log(`error:${error}`);
          loading.clear();
        });
    },

    //获取用户信息
    getUser(callback) {
      var t = this;
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._get("user", "User.getUser", params)
        .then(res => {
          if (res.status == 0) {
            t.user = res.data;
            t.isCount = !res.data.user.today_draw;
            var app_login_user = localStorage.getItem(config.login_key);
            if (app_login_user) {
              app_login_user = JSON.parse(app_login_user);
              app_login_user.userid = t.user.user.id;
              localStorage.setItem(
                config.login_key,
                JSON.stringify(app_login_user)
              );
              console.log("home t._wxReadySuccessFun");
              t._wxReadySuccessFun();
            }
            typeof callback == "function" && callback();
            // t.firstloading = true;
          } else {
            typeof callback == "function" && callback(error);
          }
        })
        .catch(error => {
          typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
        });
    },
    //获取前10名中奖人信息
    getAwardUsers() {
      var t = this;
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      t._get("user", "User.getAwardUsers", params)
        .then(res => {
          if (res.status == 0) {
            var list = res.data.loginfo;
            t.notice = list;
            // for (var i = 0; i < list.length; i++) {
            //   t.notice += list[i].user_tel + "获得" + list[i].award_name + ";";
            // }
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    //立即抽奖接口
    getAward() {
      var t = this;
      if (!t.isbindtel) {
        t.$router.push({
          path: "/phone",
          query: {
            a: t.urlData.a
          }
        });
        return false;
      }
      if (t.truntable_status != 0) return;
      t.truntable_status = 1;
      t.rotate();
      // t.turntable_res = 3;
      // t.cur = 1;
      // t.turntable_error = true;
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      var img1 = new Image();
      img1.src = require("../../static/images/alert01.png");
      img1.onload = function() {};
      var img2 = new Image();
      img2.src = require("../../static/images/alert02.png");
      img2.onload = function() {};

      t._get("activity", "Activity.draw", params)
        .then(res => {
          if (res.status == 0) {
            res.data.award.expireFormat = df.formatdate(
              "Y年m月d日",
              res.data.award.code_expire_t * 1000
            );
            t.award = res.data.award;
            // t.isShow = true;
            t.iswin = 1;

            for (var i = 0; i < t.info.award_list.length; i++) {
              if (t.award.id == t.info.award_list[i].id) {
                t.turntable_res = i;
                t.cur = i;
                break;
              }
            }
            if (t.user && t.user.user && t.user.user.total_draw_num) {
              t._deepmain(
                "h5open2",
                `yycj#h5open2#clickbutton${t.user.user.total_draw_num}`,
                2
              );
            }
          } else if (res.status == 60001) {
            //抽奖次数已用完  抽奖次数没有了的出现弹窗
            if (/只能抽奖[\d]+次/g.test(res.msg)) t.isCountUpper = true;
            else t.isCount = true;
            t._deepmain("h5open6", "yycj#h5open6", 2);
            t.cur = -1;
            for (var i = 0; i < t.info.award_list.length; i++) {
              if (t.info.award_list[i].id == 0) {
                t.cur = i;
                break;
              }
              // 如果没有谢谢参与的奖品
              if (i == t.info.award_list.length - 1) {
                t.cur = -1;
              }
            }
            console.log("t.cur");
            console.log(t.cur);
            t.turntable_error = true;
          } else {
            // t.isShow = true;
            t.iswin = 0;
            for (var i = 0; i < t.info.award_list.length; i++) {
              if (t.info.award_list[i].id == 0) {
                t.cur = i;
                break;
              }
              // 如果没有谢谢参与的奖品
              if (i == t.info.award_list.length - 1) {
                t.cur = -1;
              }
            }
            t.turntable_res = t.cur;
          }
          // t.getUser();
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    // 转盘转起来
    rotate(idx) {
      var t = this;
      if (typeof idx == "undefined") idx = t.turntable_idx;
      t.turntable_nowtime += t.truntable_speed;
      t.turntable_idx = idx;
      if (!t.turntable_error) {
        t.cur = t.turn[idx];
        //已经获得抽奖结果，准备停止
        if (
          t.turntable_res > -1 &&
          t.turntable_nowtime >= t.turntable_mintime
        ) {
          t.turntable_stoptime += t.truntable_speed;
          t.truntable_speed += 40;
        }
        if (
          t.turntable_res != t.turn[idx] ||
          t.turntable_stoptime < t.turntable_minstoptime
        ) {
          idx++;
          if (idx > 7) {
            idx = 0;
          }
          setTimeout(function() {
            t.rotate(idx);
          }, t.truntable_speed);
          // var idx = -1;
          // setTimeout(function() {
          //   if (t.turn[idx] != t.cur) {
          //     console.log("t.cur999");
          //     console.log(t.cur);
          //     console.log(t.turn[idx]);
          //     t.cur = t.turn[idx];
          //     idx++;
          //     if (idx >= 7) {
          //       idx = 0;
          //     }
          //     t.rotate(idx);
          //   }
          // }, t.truntable_speed);
        }
        //停止了
        else {
          t.truntable_speed = 50;
          t.turntable_nowtime = 0;
          t.turntable_stoptime = 0;
          t.truntable_status = 0;
          // t.turntable_res
          setTimeout(() => {
            t.isShow = true;
            if (t.user.user.total_draw_num + t.user.user.award_num < 3) {
              t.user.user.total_draw_num += 1;
              t.user.user.award_num += 1;
            } else {
              t.getUser();
            }
          }, 100);
        }
      }
      //出错了
      else {
        t.cur = -1;
        t.truntable_speed = 50;
        t.turntable_nowtime = 0;
        t.turntable_stoptime = 0;
        t.truntable_status = 0;
        t.turntable_error = false;
        t.getUser();
      }
    },

    // 获取我所有的推荐人列表
    getMyRecommendUser() {
      var t = this;
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._get("user", "User.getMyRecommendUser", params)
        .then(res => {
          if (res.status == 0) {
            t.myuser = res.data.recommend_list;
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    keyUrl() {
      var items = [];
      var url = location.href;
      if (url === undefined || typeof url != "string") {
        return null;
      }
      var json = {};
      var newurl = url.split("#")[0];
      var arr = newurl.split("?");
      if (arr.length > 1) {
        items = arr[1].split("&");
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i].split("=");
          json[item[0]] = item[1];
        }
      }
      return json;
    },

    initData(callback) {
      var t = this;
      console.log("window load-----------");
      console.log(window.location.href);
      t.urlData = t.keyUrl();
      var q = t.$route.query;
      if (q.a) {
        t.urlData = q;
      }
      if (t.urlData.a) {
        Vue.prototype.activityId = t.urlData.a;
        // t.activityId = t.urlData.a;
      }
      console.log("t.urlData:", t.urlData);
      setTimeout(function() {
        var userInfo = "";
        try {
          userInfo = trip.getUserInfo();
        } catch (e) {}

        console.log("userInfo:Jegotrip.getUserInfo()");
        console.log(userInfo);
        console.log("t.activityId:", t.activityId);
        console.log("t.urlData:", t.urlData);
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          t.urlData.token = userInfo.token;
          t.urlData.userId = userInfo.userCode;
          typeof callback == "function" && callback();
        } else {
          // loading.clear();
          if (t.loop < 3) {
            t.loop++;
            console.log("循环请求次数：" + t.loop);
            t.initData(callback);
          } else {
            t.loop = 0;
            typeof callback == "function" && callback("no token");
          }
        }
        // t.getteams(t.urlData.token, t.urlData.openid);
        // t.getTeamAwards(t.urlData.openid);
      }, 200 + t.loop * 200);
    }
  },
  created() {
    var t = this;
    console.log("window load-----------");
    console.log(window.location.href);
    t.urlData = t.keyUrl();
    var q = t.$route.query;
    if (q.a) {
      t.urlData = q;
    }
    if (t.urlData.clear == 1) {
      localStorage.removeItem(config.login_key);
      window.location.reload();
    }

    t.getActivityInfo();
    var userAgent = window.navigator.userAgent.toLowerCase();
    t.isapp = userAgent.match(/jegotrip/i) == "jegotrip";
    var clickShare = localStorage.getItem("clickShare");
    if (clickShare) {
      t.clickShare = clickShare;
    }

    t.channel = t._getAPPParams().channel;
    console.log("phone.vue -- t.channel", t.channel);

    t._deepmain("h5open2", "yycj#h5open2", 0);
  },
  mounted() {
    // wxapi.wxRegister(this.wxRegCallback);
  },
  components: {
    Alert
  }
};
</script>
<!-- @import并不是引入代码到<style></style>里面，而是发起新的请求获得样式资源，并且没有加scoped -->
<style scoped  lang="scss" src="../../static/scss/home.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
.home-count {
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: vw(750);
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
}
.home-count-box {
  position: relative;
  width: vw(621);
  height: vw(384);
  background-image: url("../../static/images/box_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.home-count-boxicon {
  position: absolute;
  top: vw(-98);
  right: vw(66);
  justify-content: center;
  align-items: center;
}
.box_close {
  width: vw(50);
  height: vw(50);
}
.box_line {
  width: vw(2);
  height: vw(90);
}
.home-count-text {
  margin: vw(74) 0 0;
  color: #666;
  font-size: vw(24);
  line-height: vw(48);
  justify-content: center;
  align-items: center;
}
.home-count-btn {
  margin: vw(30) vw(110) 0;
  justify-content: center;
  align-items: center;
  width: vw(400);
  height: vw(60);
  border-radius: vw(30);
  font-size: vw(24);
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(255, 92, 147, 1),
    rgba(255, 176, 208, 1)
  );
  box-shadow: 0 vw(5) vw(10) 0 rgba(220, 30, 94, 0.3);
}
.home-reward-winprize {
  width: vw(205);
  height: vw(205);
  position: absolute;
  left: vw(225);
  top: vw(225);
  z-index: 4;
  background: #ffeef4;
}
.home-reward-btn2 {
  animation: mymove 1s infinite;
  -webkit-animation: mymove 1s infinite;
}
.home-reward-btn3 {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
@keyframes mymove {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@-webkit-keyframes mymove {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}

.share-alert {
  background: rgba($color: #000000, $alpha: 0.6);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 12;
}
.share-alert-img {
  width: vw(304);
  height: vw(175);
  position: fixed;
  right: vw(77);
  top: vw(83);
  z-index: 12;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->

